import React, { useState, useEffect, useRef } from 'react';
import { message } from 'antd';
import { ChallengeConfigProvider, defaultConfig, useChallengeConfig } from '../../contexts/BlocklyConfigContext';
import Blockly, { BlocklyRef } from '../Blockly';
import { TLesson } from '../../../../models/courses/lesson';

interface LessonBlocklyPhaserTeacherProps {
  lesson: TLesson | undefined;
  onWorkspaceChange?: (workspace: string) => void;
  blocklyRef?: React.RefObject<BlocklyRef>;
}

const LessonBlocklyPhaserTeacher: React.FC<LessonBlocklyPhaserTeacherProps> = ({ lesson, onWorkspaceChange, blocklyRef: externalRef }) => {
  return (
    <ChallengeConfigProvider>
      <LessonBlocklyPhaserTeacherContent lesson={lesson} onWorkspaceChange={onWorkspaceChange} blocklyRef={externalRef} />
    </ChallengeConfigProvider>
  );
};

const LessonBlocklyPhaserTeacherContent: React.FC<LessonBlocklyPhaserTeacherProps> = ({ lesson, onWorkspaceChange, blocklyRef: externalRef }) => {
  const { setConfig } = useChallengeConfig();
  const internalBlocklyRef = useRef<BlocklyRef>(null);
  const blocklyRef = externalRef || internalBlocklyRef;

  useEffect(() => {
    if (!lesson) return;

    const baseConfig = lesson?.config?.config ?? defaultConfig();
    
    // Use teacherWorkspace instead of workspace, fallback to workspace if teacherWorkspace not available
    const teacherWorkspace = baseConfig.configWorkspace?.teacherWorkspace || baseConfig.configWorkspace?.workspace || '';

    // Set config with teacherWorkspace
    setConfig({
      ...baseConfig,
      configWorkspace: {
        ...baseConfig.configWorkspace,
        adminMode: false,
        workspace: teacherWorkspace, // Use teacherWorkspace as the workspace
      },
      configPhaser: {
        ...baseConfig.configPhaser,
      },
    });
    // eslint-disable-next-line
  }, [lesson, setConfig]);

  const onWin = () => {
    message.success('🎉 Bravo! Vous avez gagné!', 5);
  };

  const onSave = (workspace: string) => {
    // Track workspace changes for teacher mode
    onWorkspaceChange?.(workspace);
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%'
    }}>
      {/* 1. L'énoncé de l'exercice */}
      {lesson?.statement && (
        <div style={{
          fontSize: '1.1em',
          color: '#333',
          fontWeight: '600',
          marginBottom: '16px',
          whiteSpace: 'pre-wrap'
        }}>
          {lesson.statement}
        </div>
      )}

      {/* 2. L'espace de travail Blockly */}
      <div style={{ flex: 1 }}>
        <Blockly ref={blocklyRef} onWin={onWin} onSave={onSave} adminMode={false} />
      </div>
    </div>
  );
};

export default LessonBlocklyPhaserTeacher;

